import React, { useEffect, useRef, useState } from "react";
import SVGProfile from "./SVGProfile";

function Profile() {
    const svgRef = useRef(null);

    // Eye centers (SVG coords)
    const [leftEyeCenter, setLeftEyeCenter] = useState({ x: 0, y: 0 });
    const [rightEyeCenter, setRightEyeCenter] = useState({ x: 0, y: 0 });

    // Mouse position in SVG coords
    const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

    // How far the iris can move
    const irisRadius = 40;

    // 1) Measure each eye’s center from their bounding boxes
    useEffect(() => {
        if (!svgRef.current) return;

        const leftElem = svgRef.current.querySelector("#Eye-L-Bottom");
        const rightElem = svgRef.current.querySelector("#Eye-R-Bottom");

        if (leftElem && rightElem) {
            const leftBbox = leftElem.getBBox();
            setLeftEyeCenter({
                x: leftBbox.x + leftBbox.width / 2,
                y: leftBbox.y + leftBbox.height / 2,
            });

            const rightBbox = rightElem.getBBox();
            setRightEyeCenter({
                x: rightBbox.x + rightBbox.width / 2,
                y: rightBbox.y + rightBbox.height / 2,
            });
        }
    }, []);

    // 2) Convert the mouse’s screen coords → the SVG’s local coords
    useEffect(() => {
        const handleMouseMove = (e) => {
            if (!svgRef.current) return;

            const svg = svgRef.current;
            const pt = svg.createSVGPoint();
            pt.x = e.clientX;
            pt.y = e.clientY;
            // Convert screen coords to SVG coords
            const svgP = pt.matrixTransform(svg.getScreenCTM().inverse());
            setMousePos({ x: svgP.x, y: svgP.y });
        };
        window.addEventListener("mousemove", handleMouseMove);
        return () => window.removeEventListener("mousemove", handleMouseMove);
    }, []);

    // 3) Compute and apply the iris transforms
    useEffect(() => {
        const computeTransform = (eyeX, eyeY, mouseX, mouseY) => {
            const dx = mouseX - eyeX;
            const dy = mouseY - eyeY;
            const angle = Math.atan2(dy, dx);

            const offsetX = irisRadius * (Math.cos(angle) * 2);
            const offsetY = irisRadius * (Math.sin(angle) * 2);

            // First translate to the eye center, then offset
            return `translate(${offsetX}px, ${offsetY}px)`;
        };

        const leftTransform = computeTransform(leftEyeCenter.x, leftEyeCenter.y, mousePos.x, mousePos.y);
        const rightTransform = computeTransform(rightEyeCenter.x, rightEyeCenter.y, mousePos.x, mousePos.y);

        document.documentElement.style.setProperty("--left-iris-transform", leftTransform);
        document.documentElement.style.setProperty("--right-iris-transform", rightTransform);

    }, [leftEyeCenter, rightEyeCenter, mousePos]);

    return <SVGProfile ref={svgRef} width={200} height={200} />;
}

export default Profile;
